/**
 * 客资处理状态。
 *
 * 状态由系统事实自动派生，禁止用户、导入或平台映射直接写入：
 * 公海 → 已分配 → 跟进中 → 已成交。
 */
export enum CrmRecordStatus {
  POOL = 'pool',
  ASSIGNED = 'assigned',
  FOLLOWING = 'following',
  DEAL = 'deal',
}

/** 会影响客资处理状态的专用业务动作。 */
export enum CrmRecordTransitionAction {
  ASSIGN = 'assign',
  FOLLOW_UP = 'follow_up',
  RETURN_POOL = 'return_pool',
  DEAL = 'deal',
}

/** 处理漏斗顺序。 */
export const CRM_RECORD_STATUS_ORDER: readonly CrmRecordStatus[] = [
  CrmRecordStatus.POOL,
  CrmRecordStatus.ASSIGNED,
  CrmRecordStatus.FOLLOWING,
  CrmRecordStatus.DEAL,
];

/** 每种业务动作允许操作的当前状态。 */
export const CRM_RECORD_ACTION_ALLOWED_STATUSES: Readonly<
  Record<CrmRecordTransitionAction, readonly CrmRecordStatus[]>
> = {
  [CrmRecordTransitionAction.ASSIGN]: [CrmRecordStatus.POOL, CrmRecordStatus.DEAL],
  [CrmRecordTransitionAction.FOLLOW_UP]: [CrmRecordStatus.ASSIGNED, CrmRecordStatus.FOLLOWING, CrmRecordStatus.DEAL],
  [CrmRecordTransitionAction.RETURN_POOL]: CRM_RECORD_STATUS_ORDER,
  [CrmRecordTransitionAction.DEAL]: [CrmRecordStatus.FOLLOWING, CrmRecordStatus.DEAL],
};

export const TERMINAL_STATUSES: readonly CrmRecordStatus[] = [CrmRecordStatus.DEAL];

export const CRM_RECORD_STATUS_COLOR: Record<CrmRecordStatus, string> = {
  [CrmRecordStatus.POOL]: 'default',
  [CrmRecordStatus.ASSIGNED]: 'cyan',
  [CrmRecordStatus.FOLLOWING]: 'orange',
  [CrmRecordStatus.DEAL]: 'green',
};

export const CRM_RECORD_STATUS_LABEL: Record<CrmRecordStatus, string> = {
  [CrmRecordStatus.POOL]: '公海',
  [CrmRecordStatus.ASSIGNED]: '已分配',
  [CrmRecordStatus.FOLLOWING]: '跟进中',
  [CrmRecordStatus.DEAL]: '已成交',
};
